import Drawer from 'material-ui/Drawer';
import MenuItem from 'material-ui/MenuItem';
import PropTypes from 'prop-types';
import r from 'render-dom';
import { Link } from 'react-router-dom';

import { adminMenu, dropdownMenu, loggedOutMenu, sellerMenu } from 'constants/menuItems';

const getMenuItems = ({ isLoggedIn, me }) => {
    if (!isLoggedIn) {
        return loggedOutMenu;
    }

    if (me.get('isAdmin')) {
        return [...adminMenu, ...dropdownMenu];
    }

    return [...sellerMenu, ...dropdownMenu];
};

const navItems = (items, onClick) => items.map(({ label, url }, index) => (
    r(MenuItem, {
        containerElement: r(Link, { to: url }),
        key: index,
        onClick,
        primaryText: label,
        to: url,
    })
));

const SideMenu = ({
    isLoggedIn,
    me,
    showSideMenu = false,
    toggleSideMenu,
}) => {
    const menuItems = getMenuItems({ isLoggedIn, me });

    return (
        r(Drawer, {
            docked: false,
            onRequestChange: toggleSideMenu,
            open: showSideMenu,
            openSecondary: true
        }, [
            navItems(menuItems, toggleSideMenu),
        ])
    );
};

SideMenu.propTypes = {
    showSideMenu: PropTypes.bool.isRequired,
    toggleSideMenu: PropTypes.func.isRequired,
};

export default SideMenu;



// WEBPACK FOOTER //
// ./src/components/public/Navigation/NavigationBar/SideMenu/index.js